module.exports = __webpack_public_path__ + "static/media/approval-logo.d2eef3fa.svg";